import React, { FC } from 'react';
import ReactDOM from 'react-dom';
import Blog from './components/Blog/Blog';
import styled from 'styled-components';

const Container = styled.div`
  @media (min-width: 993px) {
    padding-top: 56px; 
  }
`;

const renderTarget = 'blog-template-react-target';

const Index: FC = () => {
  return (
    <Container>
      <Blog />
    </Container>
  );
};

ReactDOM.render(<Index />, document.getElementById(renderTarget));